<template>
  <el-dialog :close-on-click-modal="false" :title="isEdit ? '编辑' : '添加'" :visible.sync="isShow" width="500px">
    <div>
      <span style="margin:0 5px;">模板主题名称:</span>
      <el-input v-model="themeName" style="width:200px;"></el-input>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="isShow = false">取 消</el-button>
      <el-button type="primary" @click="finish()">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { themeAdd, themeUpdate } from '@/api/auxx.js'
export default {
  data () {
    return {
      info: {},
      isEdit: false,
      themeName: '',
      isShow: false
    }
  },
  methods: {
    show (row) {
      row && this.init(row)
      this.isShow = true
    },
    hide () {
      this.$emit('success')
      this.isShow = false
    },
    init (row) {
      console.log(row)
      this.themeName = row.themeName
      this.info = row
      this.isEdit = true
    },
    finish () {
      console.log(this.isEdit)
      if (!this.themeName) {
        this.$message.error('请输入模板主题')
        return
      }
      if (this.isEdit) {
        themeUpdate({
          themeId: this.info.themeId,
          themeName: this.themeName
        })
          .then(res => {
            if (res.data.success) {
              this.$message.success('编辑成功')
              this.hide()
            }
          })
      } else {
        themeAdd({
          attachType: 'HQ',
          themeName: this.themeName
        })
          .then(res => {
            if (res.data.success) {
              this.$message.success('添加成功')
              this.hide()
            }
          })
      }
    }
  }
}
</script>

<style lang="less" scoped>
</style>
